import axios from "axios";
import API from "../_helpers/endpointService";

export const getMOM_ListView = (data, id) => {
  let apiUrl = API.MOM_LISTVIEW + "?projectId=" + id + "&Material=" + data.Material + '&PageNumber=' + data.PageNumber + '&PageSize=' + data.PageSize;
  return (dispatch) => {
    dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          dispatch({ type: "MOM_LISTVIEW", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        dispatch({ type: "SHOW_LOADER", data: false })
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const getMOM_Materials = () => {
  let apiUrl = API.MASTERDATA_MATERIAL;
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "MASTERDATA_MATERIAL", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
}
export const gethistorylogMOM = (id) => {
  let apiUrl = API.HISTORY_LOG + id + '?name=MatrixOfMaterial'
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "HISTORY_LOG", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const putMOM = (data, id) => {
  let apiUrl = API.MOM_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "PUT",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "MOMEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const geteditmominfo = (data, id) => {
  let apiUrl = API.MOM_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "GET",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        if (response?.status === 200) {
          dispatch({ type: "MOMEDIT_DOCS", data: response.data });
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const deletemultiMOM = (data, id) => {
  let ids = "";
  if (data && data.length > 0) {
    data.map((val, index) => {
      if (index == 0) {
        ids += "ids=" + val.data;
      }
      else {
        ids += "&ids=" + val.data;
      }
    })
  }

  let apiUrl = API.MOM_LISTVIEW + '/ids?' + ids;
  return (dispatch) => {
    axios({
      method: "delete",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};
export const deleteMOM = (id) => {
  let apiUrl = API.MOM_LISTVIEW + '/' + id;
  return (dispatch) => {
    axios({
      method: "delete",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
        } else {
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
        }
      });
  };
};